import api from '@/libs/api'
import store from '@/store'

const getProjectId = () => store.state.app.projectId

export default {
  namespaced: true,
  state: {
    fetchingJobAnalytics: false,
    jobAnalytics: null,
    fetchingOutputAnalytics: false,
    outputAnalytics: null,
    fetchingEncodingAnalytics: false,
    encodingAnalytics: null,
    fetchingProjectAnalytics: false,
    projectAnalytics: null,
    fetchingQualityAnalytics: null,
    qualityAnalytics: null,
  },
  mutations: {
    SET_JOB_ANALYTICS(state, value) {
      state.jobAnalytics = value
    },
    SET_FETCHING_JOB_ANALYTICS(state, value) {
      state.fetchingJobAnalytics = value
    },
    SET_OUTPUT_ANALYTICS(state, value) {
      state.outputAnalytics = value
    },
    SET_FETCHING_OUTPUT_ANALYTICS(state, value) {
      state.fetchingOutputAnalytics = value
    },
    SET_ENCODING_ANALYTICS(state, value) {
      state.encodingAnalytics = value
    },
    SET_FETCHING_ENCODING_ANALYTICS(state, value) {
      state.fetchingEncodingAnalytics = value
    },
    SET_PROJECT_ANALYTICS(state, value) {
      state.projectAnalytics = value
    },
    SET_FETCHING_PROJECT_ANALYTICS(state, value) {
      state.fetchingProjectAnalytics = value
    },
    SET_QUALITY_ANALYTICS(state, value) {
      state.qualityAnalytics = value
    },
    SET_FETCHING_QUALITY_ANALYTICS(state, value) {
      state.fetchingQualityAnalytics = value
    },
  },
  actions: {
    fetchJobAnalytics({ commit }, interval) {
      const query = interval !== null ? `?filter=${interval}` : ''
      commit('SET_FETCHING_JOB_ANALYTICS', true)
      return new Promise((resolve, reject) => {
        api('encoder').get(`projects/${getProjectId()}/analytics/jobs${query}`)
          .then(response => {
            commit('SET_FETCHING_JOB_ANALYTICS', false)
            commit('SET_JOB_ANALYTICS', response.data.result)
            resolve(response)
          })
          .catch(error => {
            commit('SET_FETCHING_JOB_ANALYTICS', false)
            reject(error)
          })
      })
    },
    fetchOutputAnalytics({ commit }, interval) {
      const query = interval !== null ? `?filter=${interval}` : ''
      commit('SET_FETCHING_OUTPUT_ANALYTICS', true)
      return new Promise((resolve, reject) => {
        api('encoder').get(`projects/${getProjectId()}/analytics/outputs${query}`)
          .then(response => {
            commit('SET_FETCHING_OUTPUT_ANALYTICS', false)
            commit('SET_OUTPUT_ANALYTICS', response.data.result)
            resolve(response)
          })
          .catch(error => {
            commit('SET_FETCHING_OUTPUT_ANALYTICS', false)
            reject(error)
          })
      })
    },
    fetchEncodingAnalytics({ commit }, interval) {
      const query = interval !== null ? `?filter=${interval}` : ''
      commit('SET_FETCHING_ENCODING_ANALYTICS', true)
      return new Promise((resolve, reject) => {
        api('encoder').get(`projects/${getProjectId()}/analytics/average-times${query}`)
          .then(response => {
            commit('SET_FETCHING_ENCODING_ANALYTICS', false)
            commit('SET_ENCODING_ANALYTICS', response.data.result)
            resolve(response)
          })
          .catch(error => {
            commit('SET_FETCHING_ENCODING_ANALYTICS', false)
            reject(error)
          })
      })
    },
    fetchProjectAnalytics({ commit }, interval) {
      const query = interval !== null ? `?filter=${interval}` : ''
      commit('SET_FETCHING_PROJECT_ANALYTICS', true)
      return new Promise((resolve, reject) => {
        api('encoder').get(`projects/${getProjectId()}/analytics/projects${query}`)
          .then(response => {
            commit('SET_FETCHING_PROJECT_ANALYTICS', false)
            commit('SET_PROJECT_ANALYTICS', response.data.result)
            resolve(response)
          })
          .catch(error => {
            commit('SET_FETCHING_PROJECT_ANALYTICS', false)
            reject(error)
          })
      })
    },
    fetchQualityAnalytics({ commit }, interval) {
      const query = interval !== null ? `?filter=${interval}` : ''
      commit('SET_FETCHING_QUALITY_ANALYTICS', true)
      return new Promise((resolve, reject) => {
        api('encoder').get(`projects/${getProjectId()}/analytics/qualities${query}`)
          .then(response => {
            commit('SET_FETCHING_QUALITY_ANALYTICS', false)
            commit('SET_QUALITY_ANALYTICS', response.data.result)
            resolve(response)
          })
          .catch(error => {
            commit('SET_FETCHING_QUALITY_ANALYTICS', false)
            reject(error)
          })
      })
    },
  },
}
